module.exports = __webpack_public_path__ + "static/media/letter_h.939323c7.m4a";